module.exports = __webpack_public_path__ + "img/set_300.65b3a17c.png";